import { Outlet } from 'react-router-dom';
import { Box } from '@mui/system';
import { Suspense, useState } from 'react';
import PersistentCollapsibleDrawer from '../PeristantCollapseableDrawer';
import { appName } from '../../enum/UrlAppMap';
import { AppHeader, Footer } from '@brady/react-core';

export interface IRootLayoutProps {
  setScrollToNewest: (scrollToNewest: boolean) => void;
  selectedApp: appName;
}

export default function RootLayout(props: IRootLayoutProps) {
  const [open, setOpen] = useState(false);
  const showEsaInfo = props.selectedApp === 'Expert Sales Assistant';

  return (
    <Box className="flex-column" sx={{ flexGrow: 1, height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <AppHeader disableOptions={{disableImagen: true, disableBeaker: true, disableCustomLocks: true}} appTitle={props.selectedApp} environment={'prod'} onHamburgerMenuClick={() => setOpen(!open)} appTitleComponent={'h1'}  bradyLogoRedirect={'/home'}/>
      <Box className="flex-row" sx={{ flexGrow: 1, overflowY: 'hidden', display: 'flex', minHeight: 0 }}>
        <PersistentCollapsibleDrawer
          open={open}
          setOpen={setOpen}
          setScrollToNewest={props.setScrollToNewest}
          showEsaInfo={showEsaInfo}
        />
        <Box className="flex-column" sx={{ flexGrow: 1, overflowX: 'hidden', display: 'flex', flexDirection: 'column', minHeight: 0 }}>
          <Box sx={{ flexGrow: 1, overflowY: 'auto' }}>
            <Suspense fallback={<div>Loading...</div>}>
              <Outlet />
            </Suspense>
          </Box>
          <Footer />
        </Box>
      </Box>
    </Box>
  );
}
